import InviteAgent from './InviteAgent'

export default InviteAgent
